import * as PXBColors from '@brightlayer-ui/colors';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles(() =>
    createStyles({
        Red: {
            backgroundColor: PXBColors.red[500],
            boxShadow: `0px 0px 4px 0px ${PXBColors.red[100]}`,
            border: `5px solid ${PXBColors.red[100]}`,
            color: PXBColors.white[500],
        },
        Green: {
            backgroundColor: PXBColors.green[500],
            boxShadow: `0px 0px 4px 0px ${PXBColors.green[100]}`,
            border: `5px solid ${PXBColors.green[100]}`,
            color: PXBColors.white[500],
        },
        Yellow: {
            backgroundColor: PXBColors.yellow[500],
            boxShadow: `0px 0px 4px 0px ${PXBColors.yellow[100]} `,
            border: `5px solid ${PXBColors.yellow[100]}`,
            color: PXBColors.black[500],
        },
        Grey: {
            backgroundColor: PXBColors.gray[500],
            boxShadow: `0px 0px 4px 0px ${PXBColors.gray[100]} `,
            border: `5px solid ${PXBColors.gray[100]}`,
            color: PXBColors.white[500],
        },
        positionDiv: {
            position: 'relative',
        },
        badgeAlign: {
            position: 'relative',
            top: '13px',
        },
        iconAlignment: {
            float: 'right',
            color: 'gray',
        },
        iconStyle: {
            fontSize: '20px',
            lineHeight: '12px',
            position: 'relative',
            top: '3px',
        },
        relAvatar: {
            fontSize: '15px',
            lineHeight: '14px',
            fontWeight: 700,
            marginBottom: '25px',
            fontFamily: 'open sans',
            width: '63px',
            height: '63px',           
            marginRight: '10px'
        }       
    })
);

export { useStyles};
